import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-ivory py-9 sm:py-12" aria-labelledby="guarantee-title" data-id="element-70" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl px-5 text-center sm:px-8" data-id="element-71" data-mp="223el1k29z72x">
        <ShieldCheckIcon className="mx-auto h-8 w-8 text-teal" aria-hidden="true" data-id="element-72" data-mp="222n1j7lyczt0" />
        <h2 id="guarantee-title" className="mt-2.5 font-display text-[18px] font-semibold uppercase leading-tight tracking-tightish text-navy-deep sm:text-2xl" data-id="element-73" data-mp="1x5muouha3t0u">
          7-day money-back guarantee
        </h2>
        <p className="mx-auto mt-2 max-w-md text-[13.5px] leading-snug text-navy-soft sm:text-[15px]" data-id="element-74" data-mp="14dtide4cbrox">
          Explore the complete system and see whether it fits your professional practice. If it
          isn&apos;t right for you, request a refund within 7 days.
        </p>
      </div>
    </section>;
}